import React from 'react';

type Props = {
    pvPctWeighted: number | null;
    evPctWeighted: number | null;
    spi: number | null;
    pendingCount: number;
    canEdit?: boolean;
    canApprove?: boolean;
    onOpenApprovalQueue?: () => void;
    onRefresh?: () => void;
    refreshing?: boolean;
    lastRefreshedAt?: Date | null;
};

function fmtPct(n: number | null, digits = 1) {
    return n == null || !Number.isFinite(n) ? '—' : `${n.toFixed(digits)}%`;
}

function fmtSpi(n: number | null) {
    return n == null || !Number.isFinite(n) ? '—' : n.toFixed(2);
}

export default function OverviewToolbarV2({
    pvPctWeighted,
    evPctWeighted,
    spi,
    pendingCount,
    canApprove,
    onOpenApprovalQueue,
    onRefresh,
    refreshing,
    lastRefreshedAt,
}: Props) {
    return (
        <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
                    PV {fmtPct(pvPctWeighted)}
                </span>
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
                    EV {fmtPct(evPctWeighted)}
                </span>
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
                    SPI {fmtSpi(spi)}
                </span>

                {canApprove && (
                    <button
                        type="button"
                        onClick={onOpenApprovalQueue}
                        disabled={pendingCount <= 0}
                        className={[
                            'rounded-full px-3 py-1 text-xs font-semibold',
                            pendingCount > 0
                                ? 'bg-orange-500 text-white hover:bg-orange-600'
                                : 'bg-gray-200 text-gray-500 cursor-not-allowed',
                        ].join(' ')}
                    >
                        승인대기 {pendingCount}
                    </button>
                )}
            </div>

            <div className="flex items-center gap-2 text-xs text-gray-500">
                {lastRefreshedAt && <span>Last updated {lastRefreshedAt.toLocaleTimeString()}</span>}
                {onRefresh && (
                    <button
                        type="button"
                        onClick={onRefresh}
                        disabled={!!refreshing}
                        className="text-xs rounded-lg px-2.5 py-1.5 border text-amber-600 hover:bg-gray-50 disabled:opacity-50"
                    >
                        {refreshing ? 'Refreshing...' : 'Refresh'}
                    </button>
                )}
            </div>
        </div>
    );
}
